import React, { FC, useState, useLayoutEffect } from 'react';
import { Setting } from '../App';
import classes from '../asset/css/main.module.css';
import { usePaymentMethodUpdate } from '../hooks/use-payment-method-update';
import { Method } from '../components/payment-method/Method';
import { useHistory } from 'react-router-dom';
import { PaymentMethodType } from '../types/payment-method-type';

export const PaymentMethod: FC<{ setting: Setting }> = ({ setting }) => {
  const history = useHistory();
  const [subscriptionContractId, setSubscriptionContractId] = useState('');
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethodType>();

  const { update } = usePaymentMethodUpdate(setting, setSubscriptionContractId, setPaymentMethod);

  useLayoutEffect(() => {
    const height = document.querySelector('body')!.scrollHeight

    setting.resize(height)
  }, [paymentMethod])

  return (
    <>
      <div className={classes.mypage_subsc_container}>
        <Method
          paymentMethod={paymentMethod}
          updatePaymentMethodFunc={() => {
            update(subscriptionContractId, () => {
              history.push('/paymentMethod/complete');
            });
          }}
        />
      </div>
    </>
  );
};
